export enum DocumentSettingType {
    /** 文档模板编辑 */
    DOCUMENT_TEMPLATE = "documentTemplate",
    /** 资料工程文件编辑 */
    DATA_PROJECT_FILE = "dataProjectFile",
}

export enum DocumentFileType {
    WORD = '0',
    DOC = '0',
    EXCEL = '1',
    XLS = '1',
    PDF = 'pdf',
}

export const FileExtensionTypeMap = {
    'docx': DocumentFileType.WORD,
    'doc': DocumentFileType.WORD,
    'xlsx': DocumentFileType.EXCEL,
    'xls': DocumentFileType.EXCEL,
}

// dateFormat: 'yyyy.mm.dd',
// dateFormat: 'yyyy年mm月dd日',
// 日期格式枚举，长日期，短日期
export enum DocumentDateFormat {
    DATE_LONG = 'yyyy年mm月dd日',
    DATE_SHORT = 'yyyy.mm.dd',
}

/**
 * 字段类型枚举
 */
export enum FieldType {
    /** 系统-企业 qyxx */
    SYSTEM_COMPANY = "qyxx",

    /** 系统-人员 ryxx */
    SYSTEM_PERSON = "ryxx",

    /** 短文本 dwb */
    SHORT_TEXT = "dwb",

    /** 长文本 cwb */
    LONG_TEXT = "cwb",

    /** 长日期 crq */
    DATE_LONG = "crq",

    /** 短日期 drq */
    DATE_SHORT = "drq",

    // SINGLE_CHECKBOX
    SINGLE_CHECKBOX = "dx",

    /** 复选 fx */
    CHECKBOX = "fx",

    /** 数值 sz */
    NUMBER = "sz",

    /** 手机号码 sjhm */
    // MOBILE = "sjhm",

    /** 邮箱 yx */
    // EMAIL = "yx",

    /** 图片 tp */
    IMAGE = "tp",

    // 下拉单选
    DROPDOWN = "lb",
}

// 字段类型文本映射
export const FieldTypeTextMap = {
    [FieldType.SYSTEM_COMPANY]: "企业信息",
    [FieldType.SYSTEM_PERSON]: "人员信息",
    [FieldType.SHORT_TEXT]: "短文本",
    [FieldType.LONG_TEXT]: "长文本",
    [FieldType.DATE_LONG]: "长日期",
    [FieldType.DATE_SHORT]: "短日期",
    [FieldType.DROPDOWN]: "下拉域",
    [FieldType.SINGLE_CHECKBOX]: "单选",
    [FieldType.CHECKBOX]: "复选",
    [FieldType.NUMBER]: "数值",
    // [FieldType.MOBILE]: "手机号码",
    // [FieldType.EMAIL]: "邮箱",
    [FieldType.IMAGE]: "图片",
};

// 字段类型选项
export const FieldTypeOptions = Object.keys(FieldType).map(key => ({
    label: FieldTypeTextMap[FieldType[key]],
    value: FieldType[key],
}));

export interface DomainFieldOption {
    label: string;
    value: string | number;
}
// 域字段类型枚举
// export enum DomainFieldType {
//     TEXT = 'text',
//     DROPDOWN = 'dropdown',
//     CHECKBOX = 'checkbox',
//     DATE = 'date',
//     IMAGE = 'image',
// }

// export interface DomainFieldConfig {
//     id: string;
//     name: string; // 显示名称，如"域1"、"域2"
//     type: FieldType;
//     key: string; // 域的唯一标识
//     title: string; // 域的标题
//     placeholder?: string;
//     required?: boolean;
//     value?: any | any[];
//     options?: DomainFieldOption[]; // 下拉框选项
//     defaultValue?: any;
//     tip?: string;
//     contentSetting?: any;
//     fieldName?: string;
//     noField?: boolean; // 是否不显示域
// }
// 域字段选项接口
export interface FieldOption {
    label: string;
    value: string | number;
}
export interface DomainFieldConfig {
    fieldTag: string;
    fieldName: string;
    fieldType: FieldType;
    key: string; // 域的唯一标识
    placeholder?: string;
    value?: any | any[];
    // options?: FieldOption[]; // 下拉框选项
    defaultValue?: any;
    // 是否启用
    // 1-启用，0-禁用
    isEnable?: boolean;
    fieldValue?: any;
    tip?: string;
    content?: {
        options?: FieldOption[];
        isNewLine?: boolean;
    };
    groupName?: string;
    dateFormat?: string;
    noField?: boolean; // 是否不显示域
    children?: DomainFieldConfig[];
    parentId?: string;
}

export interface DomainGroupConfig {
    fieldTag: string;
    fieldName: string;
    title?: string;
    label?: string;
    noField?: boolean; // 是否不显示域
    fields?: DomainFieldConfig[];
}

export interface DomainTreeNodeData {
    key: string;
    title: string;
    type: "group" | "field";
    fieldConfig?: DomainFieldConfig;
    children?: DomainTreeNodeData[];
    noField?: boolean;
}

// 字典类型枚举
export enum DictFieldType {
    SHORT_TEXT = 'shortText',           // 短文本
    LONG_TEXT = 'longText',             // 长文本(1000字)
    SHORT_DATE = 'shortDate',           // 短日期（2025.06.24）
    LONG_DATE = 'longDate',             // 长日期（2025年06月24日）
    SINGLE_SELECT = 'singleSelect',     // 单选
    MULTI_SELECT = 'multiSelect',       // 复选
    NUMBER = 'number',                  // 数值
    MOBILE = 'mobile',                  // 手机号码
    EMAIL = 'email',                    // 邮箱
    IMAGE = 'image',                    // 图片
}

// 字典类型选项
export const DictFieldTypeOptions = [
    { label: '短文本', value: DictFieldType.SHORT_TEXT },
    { label: '长文本(1000字)', value: DictFieldType.LONG_TEXT },
    { label: '短日期（2025.06.24）', value: DictFieldType.SHORT_DATE },
    { label: '长日期（2025年06月24日）', value: DictFieldType.LONG_DATE },
    { label: '单选', value: DictFieldType.SINGLE_SELECT },
    { label: '复选', value: DictFieldType.MULTI_SELECT },
    // { label: '数值', value: DictFieldType.NUMBER },
    // { label: '手机号码', value: DictFieldType.MOBILE },
    // { label: '邮箱', value: DictFieldType.EMAIL },
    // { label: '图片', value: DictFieldType.IMAGE },
];

// 字典项通用接口
export interface DictItem {
    id: string;
    name: string;
    description?: string;
    enabled: boolean;
    createUser?: string;
    updateTime?: string;
    sort?: number;
}

// 带字典类型的字典项接口
export interface DictItemWithType extends DictItem {
    dictType: DictFieldType;
}

// 保存文档状态枚举
export enum SaveStatusEnum {
    default = 0,
    Saving = 1,
    Success = 2,
    Fail = 3,
}

export const SaveStatusTextMap = {
    [SaveStatusEnum.default]: '未保存',
    [SaveStatusEnum.Saving]: '保存中',
    [SaveStatusEnum.Success]: '保存成功',
    [SaveStatusEnum.Fail]: '保存失败，请重新提交',
}

export interface EditorConfig {
    document: {
        key: string;
        fileType: string;
        title: string;
    };
}


// 文件状态 文件签署状态 0编制中 1已签署 
export enum DocumentCompileFileStatus {
    COMPILING = 0,
    COMPLETED = 1,
}

export const DocumentCompileFileStatusOptions = [
    { label: '编制中', value: DocumentCompileFileStatus.COMPILING },
    { label: '已签署', value: DocumentCompileFileStatus.COMPLETED },
]
export const DocumentCompileFileStatusTextMap = {
    [DocumentCompileFileStatus.COMPILING]: '编制中',
    [DocumentCompileFileStatus.COMPLETED]: '已签署',
}